/* eslint-disable react/jsx-filename-extension */
import React from 'react'
import _identity from 'lodash/identity'

const CheckboxField = ({
  squareCheckbox,
  field,
  form: { touched, errors, setFieldValue, setFieldTouched, values },
  touchedOnBlur = false,
  normalizer = _identity,
  label,
  labelProps = {},
  containerProps = {},
  mainContainerProps = {},
  ...props
}) => {
  const setValue = value => {
    setFieldValue(field.name, normalizer(value))
  }
  const onChange = ({ target: { checked }, target }) => {
    const field = target.name

    if (props.onChange) {
      props.onChange(field, checked)
    }

    if (squareCheckbox) {
      setFieldValue(field, checked)
    } else {
      setValue(checked)
    }
  }
  const onBlur = ({ target: { checked } }) => {
    setValue(checked)
    touchedOnBlur && setFieldTouched(field.name, checked)
  }
  if (squareCheckbox) {
    return (
      <label
        className="duplicate-event-title"
        onClick={e => e.stopPropagation()}
        onKeyDown={e => e.stopPropagation()}
      >
        {field.title}
        <input
          name={field.fieldName}
          type="checkbox"
          className="duplicate-event-title-input"
          onChange={onChange}
          checked={values[field.fieldName]}
        />
        <span className="checkmark" />
      </label>
    )
  }
  return (
    <div {...mainContainerProps}>
      <div className="checkbox-switch" {...containerProps}>
        <input
          {...{ ...field, checked: field.value }}
          {...props}
          type="checkbox"
          id={field.name}
          onChange={onChange}
          onBlur={onBlur}
        />
        <label htmlFor={field.name} />
      </div>
      {label && (
        <label {...labelProps} htmlFor={field.name}>
          {label}
        </label>
      )}
    </div>
  )
}

export { CheckboxField }
